import { ActionIcon, Text } from '@mantine/core';
import { IconSquareArrowRight } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultProcessAreaResource,
    ProcessAreaMutationResourceSchema,
    useProcessAreaActions,
} from '../../../../../resource/resources/artifacts/process_area/processAreaResource';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { useMyNavigate } from '../../../../router/createdRouter';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { ProcessAreaContent } from './ProcessAreaContent';

export const ProcessAreaView = ({
    id,
    projectId,
    projectVersionId,
}: {
    id: string | undefined;
    projectId: string | undefined;
    projectVersionId: string | undefined;
}) => {
    const navigate = useMyNavigate();
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const processAreaActions = useProcessAreaActions();
    const processAreaQuery = processAreaActions.useGetResource(id);
    const updateProcessArea = processAreaActions.useUpdateResource();
    const validateProcessArea = processAreaActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProcessAreaMutationResourceSchema,
        defaultValues: defaultProcessAreaResource,
        submitHandler: async (data) => {
            await updateProcessArea.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: processAreaQuery.data,
    });

    return (
        <QueryBaseComponent name="ProcessArea" query={processAreaQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateProcessArea.data}
                    metaDataInfo={processAreaQuery.data}
                    resourceType={ResourceType.PROCESS_AREA}
                    customButtons={
                        <ActionIcon
                            variant={'transparent'}
                            size={'small'}
                            onClick={() =>
                                navigate({
                                    route: '/project/:id/active-version/:versionId/process-area/:processAreaId',
                                    routeParams: {
                                        id: projectId ?? '',
                                        versionId: projectVersionId ?? '',
                                        processAreaId: id ?? '',
                                    },
                                    searchParams: {},
                                })
                            }
                            style={{ padding: '2px' }}
                            color={'var(--mantine-color-base-button)'}
                        >
                            <IconSquareArrowRight />
                        </ActionIcon>
                    }
                >
                    <Text c="dimmed">Process Area</Text>
                </ResourceValidationTitleBar>
                <ProcessAreaContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
